import { getUserTimezone } from './getUserTimezone';

/**
 * Formats a Unix timestamp (in seconds) to user's timezone string format
 * Format: "DD Mon, YYYY | HH:MM TZ"
 * Example: "10 Jul, 2025 | 18:00 EST"
 */
export function formatTimestampToGMTString(timestamp: string): string {
  const parsedTimestamp = parseInt(timestamp);
  if (isNaN(parsedTimestamp)) return '—';

  const date = new Date(parsedTimestamp * 1000);
  if (isNaN(date.getTime())) return '—';
  const timeZone = getUserTimezone();

  // Format date in user's timezone
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });

  // Get timezone abbreviation
  const timeZoneFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short'
  });

  const parts = formatter.formatToParts(date);
  const day = parts.find(p => p.type === 'day')?.value || '1';
  const month = parts.find(p => p.type === 'month')?.value || 'Jan';
  const year = parts.find(p => p.type === 'year')?.value || '2025';
  const hours = parts.find(p => p.type === 'hour')?.value || '00';
  const minutes = parts.find(p => p.type === 'minute')?.value || '00';

  // Get timezone abbreviation
  const timeZoneParts = timeZoneFormatter.formatToParts(date);
  const timeZoneName =
    timeZoneParts
      .find(p => p.type === 'timeZoneName')
      ?.value?.replace('GMT', 'UTC') || 'UTC';

  return `${day} ${month}, ${year} | ${hours}:${minutes} ${timeZoneName}`;
}
